import { ConversationStarters } from '@gasbi/shared/common/components/AgentChat';
import { MessageThread } from '@gasbi/shared/common/components/Chat';

import { StateMessage } from '@/components/StateMessage';
import type { AgentChat } from '@/features/agents/useAgentChat';

import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { CircularProgress, Stack } from '@mui/joy';

/** The messages of the conversation; a new one shows «Чим допомогти?» with the agent's starter questions. */
export const ChatThread = ({ chat }: { chat: AgentChat }) => {
  const { agent, messages, turn, send, retryLast } = chat;

  if (chat.isLoadingConversation) {
    return (
      <Stack alignItems='center' sx={{ py: 6 }}>
        <CircularProgress size='sm' />
      </Stack>
    );
  }

  return (
    <MessageThread
      messages={messages}
      streaming={turn.isStreaming ? turn.message : null}
      onRetry={retryLast}
      emptyState={
        <StateMessage
          icon={<AutoAwesomeIcon />}
          variant='solid'
          title='Чим допомогти?'
          text={
            agent?.description ?? 'Відповіді лише в межах ваших організацій.'
          }
        >
          <ConversationStarters
            starters={agent?.conversationStarters ?? []}
            disabled={turn.isStreaming || !agent}
            onPick={text => void send(text)}
          />
        </StateMessage>
      }
    />
  );
};
